import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

const ParallaxBanner = ({image, title}) => ( 
  <div className="hero--banner text-white m-mh-100vh  ">
      <div className="parallax--image bg-image">
          <GatsbyImage className='project-image bg-image initial--zoom' image={image.gatsbyImageData} alt={title} />
      </div>    
      <h1 className="hero--title h1 mta">{title}</h1>
  </div>     
) 
export default ParallaxBanner
